// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import wrapInContainerStyles from "@insite/client-framework/Common/wrapInContainerStyles";
import { staticListProductListLineStyles } from "@insite/content-library/Widgets/StaticList/StaticListProductListLine";
import PlusRound from "@rugby/XDL/Icons/PlusRound";
import { MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

staticListProductListLineStyles.lineInnerContainer = {
    gap: 10,
    css: css`
        ${staticListProductListLineStyles.lineInnerContainer?.css}
        div[class^="GridOffset"] {
            width: auto;
        }
    `,
};

staticListProductListLineStyles.imageGridItem = {
    width: [12, 3, 2, 2, 2],
    printWidth: 1,
    css: css`
        ${MediaQuery.lte("sm")} {
            justify-content: center;
        }
    `,
};

staticListProductListLineStyles.imageWrapper = {
    css: css`
        ${MediaQuery.lte("sm")} {
            width: 116px;
            height: 92px;
            min-width: 116px;
            min-height: 92px;
            overflow: hidden;
            margin-bottom: 10px;
        }
    `,
};

staticListProductListLineStyles.productPartNumbersStyles = undefined;

staticListProductListLineStyles.priceAndAvailabilityGridItem = {
    width: [12, 12, 5, 4, 4],
    printWidth: 5,
};

staticListProductListLineStyles.descriptionGridItem = {
    width: [12, 8, 5, 4, 4],
    printWidth: 6,
    css: css`
        flex-direction: column;
    `,
};

staticListProductListLineStyles.partNumbersHidden = {
    css: css`
        margin: 10px -5px -5px;
    `,
};

staticListProductListLineStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "secondary.main",
        css: css`
            min-height: 37px;
            margin-bottom: 7px;
            display: inline-flex;
        `,
        typographyProps: {
            color: "secondary.main",
            size: 16,
            css: css`
                width: 100%;
                line-height: 18px;
                letter-spacing: 0;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                max-height: calc(4 * 18px);
                -webkit-line-clamp: 2;
                ${wrapInContainerStyles}
            `,
        },
    },
};

staticListProductListLineStyles.productQuantityOrderedStyles = {
    labelProps: {
        css: css`
            display: none;
        `,
    },
    cssOverrides: {
        formInputWrapper: css`
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                -webkit-appearance: none;
                margin: 0;
            }
        `,
        inputSelect: css`
            -moz-appearance: textfield;
            text-align: center;
        `,
    },
};

staticListProductListLineStyles.productPriceStyles = {
    priceLabelText: {
        css: css`
            display: none;
        `,
    },
};

staticListProductListLineStyles.addToListLink = {
    link: {
        color: "secondary",
        typographyProps: {
            size: 14,
            ellipsis: true,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
            `,
        },
        icon: {
            iconProps: {
                src: PlusRound,
                color: "secondary",
                size: 12,
            },
        },
    },
};
